import { useState, useLayoutEffect, type RefObject } from "react";

export const useFullbleed = (containerRef: RefObject<HTMLElement>) => {
  const [bleed, setBleed] = useState(0);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) {
      return;
    }

    const observer = new ResizeObserver(() => {
      const rect = el.getBoundingClientRect();
      // rect.left is the distance from the viewport edge to the container
      setBleed(rect.left);
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [containerRef]);

  return bleed;
};
